(() => {
  if (customElements.get('varia-stockists')) return;
  let libraryPromise;
  function loadLibrary(element) {
    if (window.L) return Promise.resolve(window.L);
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = element.dataset.libraryCss;
      document.head.append(css);
      const script = document.createElement('script');
      script.src = element.dataset.library; script.async = true;
      let timer = setTimeout(() => fail(), 15000);
      const fail = () => { clearTimeout(timer); script.remove(); css.remove(); libraryPromise = undefined; reject(new Error('Map unavailable')); };
      script.onerror = fail;
      script.onload = () => { clearTimeout(timer); window.L ? resolve(window.L) : fail(); };
      document.head.append(script);
    });
    return libraryPromise;
  }
  const normal = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/['’]/g, '').toLocaleLowerCase().trim();
  class VariaStockists extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelector('[data-map-intro]').hidden = false;
      this.querySelector('[data-map-load]').textContent = this.dataset.explore + ' ↗';
      this.querySelector('[data-map-load]').disabled = false;
      const options = {signal: this.controller.signal};
      this.region = this.querySelector('[data-region]');
      this.search = this.querySelector('[data-search]');
      this.locations = [...this.querySelectorAll('[data-location][data-tier="main"]')];
      this.partners = [...this.querySelectorAll('[data-partner]')];
      this.resellers = this.partners.filter(card => card.dataset.tier === 'reseller');
      const selectedRegion = this.region.value;
      [...this.region.options].filter(option => option.value && option.value !== 'all').forEach(option => option.remove());
      [...new Set(this.resellers.map(card => card.dataset.regionName))]
        .sort((a, b) => a.localeCompare(b)).forEach(region => {
          const option = document.createElement('option'); option.value = region; option.textContent = region;
          this.region.append(option);
        });
      this.region.value = selectedRegion;
      this.markers = new Map();
      this.querySelector('[data-filters]').hidden = false;
      this.querySelector('[data-map-load]').addEventListener('click', () => this.startMap(), options);
      this.locations.forEach(card => {
        const button = card.querySelector('[data-show-location]'); button.hidden = false;
        button.addEventListener('click', async () => {
          await this.startMap();
          const marker = this.markers.get(card);
          if (!marker || !this.map) return;
          this.map.setView(marker.getLatLng(), card.dataset.precision === 'region' ? 5 : 15, {animate: false}); marker.openPopup();
          this.querySelector('[data-map]').scrollIntoView({block: 'center', behavior: 'auto'});
        }, options);
      });
      this.region.addEventListener('change', () => { this.search.value = ''; this.filter(); }, options);
      this.search.addEventListener('input', () => this.filter(), options);
      this.querySelector('[data-reset]').addEventListener('click', () => { this.region.value = ''; this.search.value = ''; this.filter(); }, options);
      this.locations.forEach(card => { card.hidden = false; });
      this.filter();
      this.startMap();

    }
    filter() {
      const region = this.region.value, query = normal(this.search.value);
      const pending = !region;
      this.search.disabled = pending;
      this.partners.forEach(card => {
        if (card.dataset.tier === 'main') { card.hidden = false; return; }
        const haystack = normal(card.textContent + ' ' + card.dataset.regionName);
        card.hidden = Boolean(pending || (region !== 'all' && card.dataset.regionName !== region) || (query && !haystack.includes(query)));
      });
      const count = this.resellers.filter(card => !card.hidden).length;
      this.querySelector('[data-status]').textContent = pending ? this.dataset.choose : this.dataset.counts.replace('[resellers]', count);
      this.querySelector('[data-partners-empty]').hidden = pending || count > 0;
    }
    async startMap() {
      if (this.map || this.loading) return this.loading;
      const button = this.querySelector('[data-map-load]');
      button.disabled = true; button.textContent = this.dataset.loading;
      this.querySelector('[data-map-status]').textContent = '';
      const controller = this.controller;
      this.loading = (async () => {
        try {
          const L = await loadLibrary(this);
          if (!this.isConnected || controller.signal.aborted) return;
          const node = this.querySelector('[data-map]');
          this.map = L.map(node, {scrollWheelZoom: false, attributionControl: true}).setView([18, 95], 2);
          this.layer = L.layerGroup().addTo(this.map);
          const tiles = this.dataset.tiles;
          if (!tiles.startsWith('https://')) throw new Error('Invalid map URL');
          this.tileLayer = L.tileLayer(tiles, {maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'}).addTo(this.map);
          this.tileLayer.on('tileerror', () => { this.querySelector('[data-map-status]').textContent = this.dataset.tilesError; });
          const coverageMarkers = new Map();
          this.locations.forEach(card => {
            const lat = Number(card.dataset.lat), lon = Number(card.dataset.lon);
            if (!card.dataset.lat.trim() || !card.dataset.lon.trim() || !Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return;
            const name = card.querySelector('[data-name]').textContent;
            const coverage = card.dataset.precision === 'region';
            const coverageKey = card.dataset.regionName + ':' + lat + ':' + lon;
            const marker = (coverage && coverageMarkers.get(coverageKey)) || L.marker([lat, lon], {title: coverage ? card.dataset.regionName + ' — ' + this.dataset.distributorLabel : name, alt: coverage ? card.dataset.regionName + ' — ' + this.dataset.distributorLabel : name, keyboard: true, icon: L.divIcon({className: 'v-stockist-pin', html: '<span aria-hidden="true"></span>', iconSize: [26, 34], iconAnchor: [13, 30], popupAnchor: [0, -28]})});
            if (coverage) coverageMarkers.set(coverageKey, marker);
            this.markers.set(card, marker);
          });
          this.querySelector('[data-map-intro]').hidden = true;
          if (window.ResizeObserver) { this.resize = new ResizeObserver(() => this.map?.invalidateSize()); this.resize.observe(node); }
          this.map.invalidateSize(); this.updateMap();
        } catch (_) {
          if (!this.isConnected || controller.signal.aborted) return;
          this.map?.remove(); this.map = null;
          this.querySelector('[data-map-intro]').hidden = false;
          this.querySelector('[data-map-status]').textContent = this.dataset.unavailable;
          button.textContent = this.dataset.retry;
        } finally { button.disabled = false; this.loading = null; }
      })();
      return this.loading;
    }
    updateMap() {
      this.layer.clearLayers(); const points = [];
      const groups = new Map(); let regional = false;
      this.markers.forEach((marker, card) => {
        if (!groups.has(marker)) groups.set(marker, []);
        groups.get(marker).push(card);
        regional ||= card.dataset.precision === 'region';
      });
      groups.forEach((cards, marker) => {
        const popup = document.createElement('div'); popup.className = 'v-stockist-popup';
        cards.forEach((card, index) => {
          if (index) popup.append(document.createElement('hr'));
          const title = document.createElement('strong'); title.textContent = card.querySelector('[data-name]').textContent;
          const address = document.createElement('p'); address.textContent = card.querySelector('[data-address]').textContent;
          popup.append(title, address, card.querySelector('[data-website]').cloneNode(true));
          const directions = card.querySelector('[data-directions]');
          if (directions) popup.append(directions.cloneNode(true));
        });
        marker.bindPopup(popup); this.layer.addLayer(marker); points.push(marker.getLatLng());
      });
      this.map.closePopup();
      const status = this.querySelector('[data-map-status]');
      if (!points.length) { this.map.setView([18,95],2,{animate:false}); status.textContent = this.dataset.emptyMap; return; }
      status.textContent = '';
      this.map.fitBounds(points, {padding: [38,38], maxZoom: regional ? 5 : 14, animate: false});
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resize?.disconnect(); this.resize = null;
      this.visibility?.disconnect(); this.visibility = null;
      this.map?.remove(); this.map = null;
      this.markers?.clear(); this.loading = null;
    }
  }
  customElements.define('varia-stockists', VariaStockists);
})();
